import {Component, EventEmitter, OnInit, Output} from "@angular/core";

@Component({
  selector: "v4-custom-upload",
  templateUrl: "./custom-upload.component.html",
  styleUrls: ["./custom-upload.component.scss"],
})
export class V4CustomUploadComponent implements OnInit {
  @Output() onFilesSelected = new EventEmitter<File[]>();

  constructor() {
  }

  ngOnInit() {
  }

  triggerFileUpload() {
    // 创建一个虚拟的文件输入框
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.display = 'none';

    // 添加 input 到 DOM
    document.body.appendChild(input);

    // 添加 onchange 事件处理逻辑
    input.addEventListener('change', (event) => {
      console.log('event: ', event)
      const fileInput = event.target as HTMLInputElement;
      console.log('file input: ', fileInput)
      this.onFilesSelected.emit(Array.from(fileInput.files));
    });

    // 触发 input 元素的点击事件
    input.click();

    // 移除 input 元素，以防止其影响 DOM
    document.body.removeChild(input);
  }

}
